import axios from 'axios';
import React, { useState } from 'react'
import imageCompression from "browser-image-compression";


const Meeshoprice = () => {

    const [image, setImage] = useState(null);
    const [image2, setImage2] = useState(null);
    const [removeBg, setRemoveBg] = useState(false);
    const [addBorder, setAddBorder] = useState(true);
    const [multiVariation, setMultiVariation] = useState(20);
    const [stickers, setStickers] = useState(false);
    const [category, setCategory] = useState("Other");
    const [loading, setLoading] = useState(false);

    const [base64, setbase64] = useState('')

    const [dloading, setdLoading] = useState(false);
    const [filereducesizeloading, setfilereducesizeloading] = useState(false);

    const [data, setdata] = useState([])

    const convertToBase64 = (file) => {
        return new Promise((resolve, reject) => {
            const reader = new FileReader();

            reader.readAsDataURL(file);

            reader.onload = () => {
                resolve(reader.result);
            };

            reader.onerror = (error) => {
                reject(error);
            };
        });
    };


    const handleFile = async (e) => {
        setfilereducesizeloading(true)
        setImage2(URL.createObjectURL(e.target.files[0]));
        setImage(e.target.files[0]);
        const file = e.target.files[0];

        const options = {
            maxSizeMB: 0.2,
            initialQuality: 0.95,
            useWebWorker: true,
        };

        const compressedFile = await imageCompression(
            file,
            options
        );

        console.log(
            "Original:",
            (file.size / 1024).toFixed(2),
            "KB"
        );

        console.log(
            "Compressed:",
            (compressedFile.size / 1024).toFixed(2),
            "KB"
        );

        // console.log('fileor',file)
        // console.log('reduce',await convertToBase64(compressedFile))

        if (!file) return;

        const base64 = await convertToBase64(file);
        setbase64(base64)
        setfilereducesizeloading(false)

    };

    const handleUpload = async () => {
        if (!image) {
            alert("Please select an image");
            return;
        }

        const formData = new FormData();
        formData.append("image", image);




        try {
            setLoading(true);

            // const response = await fetch(
            //     "https://lisstify.com/api/images/generate",
            //     {
            //         method: "POST",
            //         body: formData,
            //     }
            // );

            // const data = await response.json();

            // console.log(data);
            // alert("Upload successful");

            const result = await axios.post('http://localhost:8001/contact/meeshoship', { "removeBg": removeBg, "addBorder": addBorder, "multiVariation": true, "numVariations": multiVariation, "stickers": stickers, "category": "Fashion", imageBase64: base64 }, {
                headers: {
                    // Authorization: `Bearer ${token}`,
                    "X-API-Key": "your-api-key"
                }
            })

            setdata(result?.data?.data?.images)

        } catch (error) {
            console.error(error);
            alert("Upload failed");
        } finally {
            setLoading(false);
        }
    }


    console.log(data)


    return (
        <div style={{ padding: 20 }}>
            <input
                type="file"
                accept="image/*"
                onChange={handleFile}
            />

            <br />
            <br />

            <button
                onClick={handleUpload}
                disabled={loading || filereducesizeloading}
            >
                {loading ? "Uploading..." : "Upload Image"}
            </button>
        </div>
    )
}

export default Meeshoprice